import { lazy, Suspense, StrictMode } from 'react'
import { ToastContainer } from 'react-toastify'
import UiProvider from '../contexts/UiContext'
import ErrorBoundary from '../classes/ErrorBoundary'
const FODLayout = lazy(() => import('./FODLayout'))
const FODApp = () => {
	return (
		<>
			<ErrorBoundary>
				<UiProvider>
					<StrictMode>
						<Suspense fallback={<div />}>
							<FODLayout />
						</Suspense>
					</StrictMode>
				</UiProvider>
			</ErrorBoundary>
			<ToastContainer autoClose={3000} position="bottom-right" />
		</>
	)
}
export default FODApp
